import { useEffect } from 'react';

let scriptLoaded = false;

const TASKOSAUR_URL =
  'https://garage-chatbot.staging.merqube.com/js/sdk/taskosaur-any.min.js?application-id=cmi2sme9w000jzr4x8hr2ld66';

export function useTaskosaur() {
  useEffect(() => {
    // Only load if NOT production
    // Prevent duplicate script injections
    if (import.meta.env.VITE_ENV === 'production' || scriptLoaded) return;

    scriptLoaded = true;

    const script = document.createElement('script');
    script.src = TASKOSAUR_URL;
    script.async = true;

    document.body.appendChild(script);
  }, []);
}

export default useTaskosaur;
